/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;
const SvgPlus = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M13 11V2h-2v9H2v2h9v9h2v-9h9v-2z" fill="currentcolor" />
  </Icon>
);
export { SvgPlus as Plus };
